module.exports = __webpack_public_path__ + "img/3.713ca90b.png";